import {
  WarningIcon
} from "./chunk-EBVYP6SE.mjs";

// src/label/src/error-message.tsx
import { cx } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
var ErrorComponent = ({
  disabled = false,
  errorMessage,
  errorId
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cx("flex items-center gap-2", {
        "text-interactive-disabled": disabled
      }),
      children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: cx({
              "text-state-negative-graphics": !disabled
            }),
            children: /* @__PURE__ */ jsx(WarningIcon, {})
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: cx("text-sm", {
              "text-state-negative-text": !disabled
            }),
            id: errorId,
            children: errorMessage
          }
        )
      ]
    }
  );
};

export {
  ErrorComponent
};
